"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapEntityDispatch = mapEntityDispatch;
exports.mapEntityListState = mapEntityListState;
exports.mapEntityState = mapEntityState;

var _lodash = _interopRequireDefault(require("lodash"));

var _connectors = require("../../utils/connectors");

/**
 * Maps entity item from redux to props for react-redux @connect
 * @param  {Object} model [description]
 * @param  {string|Function} id
 * @param  {Object} state
 * @param  {Object} props
 * @param  {Object} fields
 * @return {Function}
 */
function mapEntityState(model, id, state, props, fields) {
  var itemId = _lodash.default.isFunction(id) ? id(props) : id;
  return model.selectors(state, props, {
    itemId: itemId,
    fields: fields
  });
}
/**
 * Maps entity list from redux to props
 * @param  {Object} model
 * @param  {string|Function} id
 * @param  {Object} state
 * @param  {Object} props
 * @param  {Object} fields
 * @return {Function}
 */


function mapEntityListState(model, id, state, props, fields) {
  var listId = _lodash.default.isFunction(id) ? id(props) : id;
  return model.selectors(state, props, {
    listId: listId,
    fields: fields
  });
}
/**
 * Maps action creators to props for react-redux @connect
 * @param  {Object} model
 * @param  {Function} dispatch
 * @return {Function}
 */


function mapEntityDispatch(model, dispatch) {
  return (0, _connectors.generateActionCreators)(model)(dispatch);
}